"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = submitMSISDN;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.match");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//import { getConfig, ConfigDetails} from "./config"
// const defaultConfig = (offer: number, country?: string, scenario?: string) : IConfig => {
//   return {...getConfig(country || process.env.country, scenario || process.env.scenario).config, offer}
// }
var wait = function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve();
    }, ms);
  });
};

var loop = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(f, max, stop, i) {
    var r;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return f();

          case 2:
            r = _context.sent;

            if (!(stop(r) || i >= max)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", r);

          case 7:
            _context.next = 9;
            return wait(1000);

          case 9:
            return _context.abrupt("return", loop(f, max, stop, i + 1));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loop(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var getConfig = function getConfig() {
  try {
    var configs = require("../../../../../config.json");

    return configs;
  } catch (ex) {
    throw "config.json not found";
  }
};

function submitMSISDN(_x5, _x6, _x7, _x8, _x9) {
  return _submitMSISDN.apply(this, arguments);
}

function _submitMSISDN() {
  _submitMSISDN = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(window, maybeConfig, internationalMSISDN, strategy, extraParams) {
    var config;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            config = strategy ? _objectSpread({
              offer: window.pac_analytics.visitor.offer
            }, strategy.flowConfig) : _objectSpread(_objectSpread({
              offer: window.pac_analytics.visitor.offer
            }, getConfig()), maybeConfig || {});

            if (!(true == config.automaticallySubmitAllOperators && !!config.operators && config.operators.length > 0)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", submitMSISDNForMultipleOperators(window, config, internationalMSISDN, config.operators, extraParams));

          case 5:
            return _context2.abrupt("return", submitMSISDNOnce(window, config, internationalMSISDN, extraParams));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _submitMSISDN.apply(this, arguments);
}

function submitMSISDNOnce(_x10, _x11, _x12, _x13) {
  return _submitMSISDNOnce.apply(this, arguments);
}

function _submitMSISDNOnce() {
  _submitMSISDNOnce = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(window, config, internationalMSISDN, extraParams) {
    var submissionError, msisdn, slug, country, device, offer, host, bupperizeCountry, search, extraParamsQs, rockmanId, result, error;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (internationalMSISDN) {
              _context4.next = 4;
              break;
            }

            submissionError = new Error("Error in submitMSISDN() trigger-pin action");
            submissionError['type'] = "InvalidMSISDN";
            throw submissionError;

          case 4:
            msisdn = internationalMSISDN.match(/\d+/gi).join(''); // tallyman API expects international msisdn without any special character

            slug = config.slug, country = config.country, device = config.device, offer = config.offer, host = config.host;

            bupperizeCountry = function bupperizeCountry(c) {
              return c == 'gb' ? 'uk' : c;
            };

            search = window.location.search.substr(1) || '';
            extraParamsQs = !extraParams ? '' : '&' + Object.keys(extraParams).map(function (k) {
              return "".concat(k, "=").concat(extraParams[k]);
            }).join('&');
            rockmanId = window.pac_analytics.visitor.rockmanId;
            _context4.next = 12;
            return fetch("https://".concat(host, "/tallyman/v1/?action=trigger-pin&country=").concat(bupperizeCountry(country), "&slug=").concat(slug, "&device=").concat(device, "&offerId=").concat(offer, "&msisdn=").concat(msisdn, "&rockman_id=").concat(rockmanId).concat(extraParamsQs, "&").concat(search)).then(function (x) {
              return x.json();
            });

          case 12:
            result = _context4.sent;

            if (!(false === result.success)) {
              _context4.next = 21;
              break;
            }

            error = new Error("Error in submitMSISDN() trigger-pin action:\n".concat(result.message));
            error['type'] = result.message == 'ALREADY SUBSCRIBED' ? "AlreadySubscribed" : "InvalidMSISDN";
            error['productUrl'] = result.product_url ? result.product_url : "";
            console.error(error);
            throw error;

          case 21:
            return _context4.abrupt("return", {
              type: "SingleMSISDNSubmissionResult",
              pin: result.pin,
              submitPIN: function () {
                var _submitPIN = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(pin) {
                  var emptyPinError, pinResult, pinError, check, checkResult, _pinError;

                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (pin) {
                            _context3.next = 4;
                            break;
                          }

                          emptyPinError = new Error("Error in submitMSISDN() verify-pin action:\n Pin Cannot Be Empty");
                          emptyPinError['type'] = "InvalidPIN";
                          throw emptyPinError;

                        case 4:
                          _context3.next = 6;
                          return fetch("https://".concat(host, "/tallyman/v1/?action=verify-pin&country=").concat(bupperizeCountry(country), "&slug=").concat(slug, "&device=").concat(device, "&offerId=").concat(offer, "&rockman_id=").concat(rockmanId, "&pin=").concat(pin).concat(extraParamsQs)).then(function (x) {
                            return x.json();
                          });

                        case 6:
                          pinResult = _context3.sent;

                          if (!(false === pinResult.success)) {
                            _context3.next = 13;
                            break;
                          }

                          pinError = new Error("Error in submitMSISDN() verify-pin action:\n".concat(pinResult.message));
                          pinError['type'] = "InvalidPIN";
                          throw pinError;

                        case 13:
                          if (!(true === pinResult.async)) {
                            _context3.next = 27;
                            break;
                          }

                          check = function check() {
                            return fetch("https://".concat(host, "/tallyman/v1/?action=check-subscription&country=").concat(bupperizeCountry(country), "&slug=").concat(slug, "&device=").concat(device, "&offerId=").concat(offer, "&rockman_id=").concat(rockmanId, "&pin=").concat(pin).concat(extraParamsQs)).then(function (x) {
                              return x.json();
                            });
                          };

                          _context3.next = 17;
                          return loop(check, 30, function (r) {
                            return r.success;
                          }, 0);

                        case 17:
                          checkResult = _context3.sent;

                          if (!(true === checkResult.success)) {
                            _context3.next = 22;
                            break;
                          }

                          return _context3.abrupt("return", pinResult.product_url || checkResult.product_url || null);

                        case 22:
                          _pinError = new Error("Error in submitMSISDN() verify-pin action:\n".concat(checkResult.message));
                          _pinError['type'] = "InvalidPIN";
                          throw _pinError;

                        case 25:
                          _context3.next = 28;
                          break;

                        case 27:
                          return _context3.abrupt("return", pinResult.product_url || null);

                        case 28:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                function submitPIN(_x19) {
                  return _submitPIN.apply(this, arguments);
                }

                return submitPIN;
              }()
            });

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _submitMSISDNOnce.apply(this, arguments);
}

function right(r) {
  return {
    type: 'right',
    value: r
  };
}

function left(l) {
  return {
    type: 'left',
    value: l
  };
}

function foldEither(left, right, either) {
  return either.type == 'left' ? left(either.value) : right(either.value);
}

function submitMSISDNForMultipleOperators(_x14, _x15, _x16, _x17, _x18) {
  return _submitMSISDNForMultipleOperators.apply(this, arguments);
}

function _submitMSISDNForMultipleOperators() {
  _submitMSISDNForMultipleOperators = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(window, config, internationalMSISDN, operators, extraParams) {
    var results, alreadySubscribed;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Promise.all(operators.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(o) {
                var singleResult;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.prev = 0;
                        _context5.next = 3;
                        return submitMSISDNOnce(window, config, internationalMSISDN, _objectSpread(_objectSpread({}, extraParams), {}, {
                          operator: o
                        }));

                      case 3:
                        singleResult = _context5.sent;
                        return _context5.abrupt("return", right(_objectSpread(_objectSpread({}, singleResult), {}, {
                          operator: o
                        })));

                      case 7:
                        _context5.prev = 7;
                        _context5.t0 = _context5["catch"](0);
                        return _context5.abrupt("return", left(_context5.t0));

                      case 10:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[0, 7]]);
              }));

              return function (_x20) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
            results = _context8.sent;
            //@ts-ignore
            alreadySubscribed = results.find(function (r) {
              return r.type == 'left' && r.value.type == 'AlreadySubscribed';
            });

            if (!results.every(function (r) {
              return r.type == 'left';
            })) {
              _context8.next = 8;
              break;
            }

            throw results[0].value;

          case 8:
            if (!alreadySubscribed) {
              _context8.next = 12;
              break;
            }

            throw alreadySubscribed.value;

          case 12:
            return _context8.abrupt("return", {
              type: "MultiOperatorMSISDNSubmissionResult",
              submitPIN: function () {
                var _submitPIN2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(pin) {
                  var pinResults;
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return Promise.all(results.filter(function (r) {
                            return r.type == 'right';
                          }).map(function (r) {
                            return r.value;
                          }).map( /*#__PURE__*/function () {
                            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref3) {
                              var submitPIN, res;
                              return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                while (1) {
                                  switch (_context6.prev = _context6.next) {
                                    case 0:
                                      submitPIN = _ref3.submitPIN;
                                      _context6.prev = 1;
                                      _context6.next = 4;
                                      return submitPIN(pin);

                                    case 4:
                                      res = _context6.sent;
                                      return _context6.abrupt("return", right(res));

                                    case 8:
                                      _context6.prev = 8;
                                      _context6.t0 = _context6["catch"](1);
                                      return _context6.abrupt("return", left(_context6.t0));

                                    case 11:
                                    case "end":
                                      return _context6.stop();
                                  }
                                }
                              }, _callee6, null, [[1, 8]]);
                            }));

                            return function (_x22) {
                              return _ref4.apply(this, arguments);
                            };
                          }()));

                        case 2:
                          pinResults = _context7.sent;

                          if (!pinResults.every(function (p) {
                            return p.type == 'left';
                          })) {
                            _context7.next = 7;
                            break;
                          }

                          throw results[0].value;

                        case 7:
                          return _context7.abrupt("return", pinResults.find(function (p) {
                            return p.type == 'right';
                          }).value);

                        case 8:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));

                function submitPIN(_x21) {
                  return _submitPIN2.apply(this, arguments);
                }

                return submitPIN;
              }()
            });

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _submitMSISDNForMultipleOperators.apply(this, arguments);
}